// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L_mzu","option":"styles_option__Fll_f","active":"styles_active__3k3k6"};